// extracted by mini-css-extract-plugin
export var cross = "cross_sell-module--cross--eef30";
export var img_link = "cross_sell-module--img_link--90b58";
export var product_calloutsTiles = "cross_sell-module--product_callouts-tiles--d7427";
export var swtch = "cross_sell-module--swtch--bf65e";
export var tiles = "cross_sell-module--tiles--adba1";
export var title = "cross_sell-module--title--3548c";
export var title_btn = "cross_sell-module--title_btn--984d2";